<template>
  <div class="mt-4">
    <mdb-container v-if="flights.length > 0" class="rates-table w-100">
      <div class="card card-cascade narrower">
        <div
          ref="ratesTableHeader"
          class="
            calc-rates-table-panel
            view
            view-cascade
            gradient-card-header
            winter-neva-gradient
            narrower
            py-3
            mx-4
            mb-3
            d-flex
            flex-column
            align-items-around
          "
        >
          <div class="d-flex justify-content-end align-items-center">
            <div>
              <mdb-dropdown multi-level title="Add columns">
                <mdb-dropdown-toggle
                  rounded
                  size="sm"
                  slot="toggle"
                  gradient="aqua">+</mdb-dropdown-toggle>
                <mdb-dropdown-menu>
                  <ul class="list-unstyled">
                    <li
                      v-for="(column, index) in allColumns.filter(col => col.index !== null)"
                      :key="`columns-checkbox-${index}`"
                    >
                      <mdb-input
                        type="checkbox"
                        :id="`columns-checkbox-${index}`"
                        :name="`columns-checkbox-${index}`"
                        :label="column.label"
                        v-model="selectedColumns[column.index]"
                        @change="onColumnChange()"
                      />
                    </li>
                  </ul>
                </mdb-dropdown-menu>
              </mdb-dropdown>
            </div>
          </div>
        </div>
        <calc-flights-table
          :data="{columns: columns, rows: flights}"
          max-width="95%"
          min-width="95%"
          :responsive="false"
          @hide-column="onColumnChange($event, false)"
        />
      </div>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbBtnGroup,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbBtn,
  mdbInput,
  mdbContainer,
  mdbIcon,
  mdbSelect
} from 'mdbvue'
import CalcFlightsTable from './CalcFlightsTable'
import Bridge8Select from './Bridge8Select'
import {mapState, mapGetters, mapActions} from 'vuex'
import {errorCatch, formatDT} from '../utils'

export default {
  name: 'CalcFlights',
  data () {
    return {
      allColumns: [
        {
          index: 1,
          label: 'Direct',
          componentName: 'CalcFlightsTableCellDirect',
          sortCallback: row => row.via ? 1 : 0,
          sort: 'asc'
        },
        {
          index: 2,
          label: 'Route',
          componentName: 'CalcFlightsTableCellRoute',
          sortCallback: row => row.origin + (row.via || '') + row.destination,
          sort: 'asc'
        },
        {
          index: 3,
          label: 'Airline',
          componentName: 'CalcFlightsTableCellAirline',
          sortCallback: row => row.airline + (row.airline2 || ''),
          sort: 'asc'
        },
        {
          index: 4,
          label: 'Departure',
          componentName: 'CalcFlightsTableCellDeparture',
          sortCallback: row => formatDT(row.departure),
          sort: 'desc'
        },
        {
          index: 5,
          label: 'Arrival',
          componentName: 'CalcFlightsTableCellArrival',
          sortCallback: row => formatDT(row.arrival),
          sort: 'desc'
        },
        {
          index: 6,
          label: 'Weekdays',
          componentName: 'CalcFlightsTableCellWeekdays',
          sortCallback: row => row.weekdays.length,
          sort: 'desc'
        },
        {
          index: 7,
          label: 'Airplane',
          componentName: 'CalcFlightsTableCellAirplane',
          sortCallback: row => row.airplane + (row.airplane2 || '')
        }
      ],
      selectedColumns: []
    }
  },
  computed: {
    ...mapState('user', {
      stateSelectedColumns: state => state.flightsTableColumns
    }),
    ...mapGetters('user', ['isAuthenticated', 'isUser']),
    ...mapState('calc', {
      flights: state => state.flights
    }),
    columns: function () {
      return this.allColumns.filter((column, index) => {
        return index === null || this.selectedColumns[column.index]
      })
    }
  },
  methods: {
    ...mapActions('user', ['setFlightsTableColumns']),
    onColumnChange (index = null, value = null) {
      if (index !== null && value !== null) {
        this.$set(this.selectedColumns, index, value)
      }
      const newSelectedColumns = []
      for (let [key, value] of Object.entries(this.selectedColumns)) {
        if (value) {
          newSelectedColumns.push(parseInt(key))
        }
      }
      if (JSON.stringify(this.stateSelectedColumns) !== JSON.stringify(newSelectedColumns)) {
        this.setFlightsTableColumns(newSelectedColumns)
          .then(() => {
            if (this.isAuthenticated) {
              this.$notify.info({
                title: 'Flights Table Columns are saved.',
                message: '',
                position: 'top right',
                timeOut: 5000,
                closeButton: true
              })
            }
          })
          .catch(errorCatch('Flights Table Columns save failed', this))
      }
    }
  },
  mounted () {
    const calculateSelectedColumns = () => {
      const selectedColumns = {}
      this.allColumns.filter(col => col.index !== null)
        .forEach(col => {
          selectedColumns[col.index] = this.stateSelectedColumns.includes(col.index)
        })
      this.selectedColumns = selectedColumns
    }
    this.$bus.$on('profile-fetch-completed', calculateSelectedColumns)
    calculateSelectedColumns()
  },
  components: {
    Bridge8Select,
    mdbContainer,
    mdbIcon,
    mdbBtn,
    mdbInput,
    mdbBtnGroup,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    CalcFlightsTable,
    mdbSelect
  }
}
</script>

<style lang="sass" scoped>
.dropdown-toggle:after
  display: none

.grand-total
  color: whitesmoke
  text-transform: uppercase

.select-button
  color: darkslategray

  &:hover
    color: black
</style>

<style lang="sass">
.calc-rates-table-panel
  overflow: visible

  td
    word-break: break-word

.rates-table
  animation: fadein 2s

@keyframes fadein
  from
    opacity: 0
  to
    opacity: 1

.rates-additional-info
  font-size: 85%

.price-display
  font-weight: 700
  font-size: smaller
</style>



// WEBPACK FOOTER //
// src/components/CalcFlights.vue